import React from 'react';
import { FaCrown, FaGem, FaKey, FaCheckCircle, FaTimesCircle, FaBan } from 'react-icons/fa';
import './SupporterPass.css';

const badgeIcons = {
  DIAMOND: <FaGem className="badge-icon diamond" />,
  FOUNDER: <FaCrown className="badge-icon founder" />,
  NONE: <FaKey className="badge-icon none" />
};

const statusIcons = {
  ACTIVE: <FaCheckCircle className="status-icon active" />,
  INACTIVE: <FaTimesCircle className="status-icon inactive" />,
  BANNED: <FaBan className="status-icon banned" />
};

const parsePreviousIds = (ids) => {
  try {
    // Handle both stringified JSON and actual arrays/empty values
    if (!ids || ids === '[]') return [];
    const parsed = typeof ids === 'string' ? JSON.parse(ids) : ids;
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    console.error('Error parsing previous_subscription_ids:', e);
    return [];
  }
};

const SupporterPass = ({ data = [] }) => {
  return (
    <div className="database-viewer-table">
      {data.length > 0 ? (
        <table className="styled-table">
          <thead>
            <tr>
              <th>Subscription ID</th>
              <th>Email</th>
              <th>Badge</th>
              <th>Vote Weight</th>
              <th>Status</th>
              <th>Previous IDs</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => {
              const previousIds = parsePreviousIds(item.previous_subscription_ids);
              return (
                <tr key={item.current_subscription_id}>
                  <td className="monospace">{item.current_subscription_id}</td>
                  <td>{item.email}</td>
                  <td className="badge-cell">
                    {badgeIcons[item.badge]}
                    <span className="badge-label">{item.badge}</span>
                    {item.badgeId && <span className="badge-id">{item.badgeId}</span>}
                  </td>
                  <td className={`vote-weight weight-${Math.min(item.voteWeight, 5)}`}>
                    {item.voteWeight}x
                  </td>
                  <td className="status-cell">
                    {statusIcons[item.status]}
                    <span>{item.status}</span>
                  </td>
                  <td className="previous-ids">
                    {previousIds.length > 0 ? (
                      <details>
                        <summary>{previousIds.length} previous</summary>
                        <ul>
                          {previousIds.map((id, index) => (
                            <li key={index} className="monospace">{id}</li>
                          ))}
                        </ul>
                      </details>
                    ) : (
                      'None'
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className="no-data-message">
          No supporter pass data available
        </div>
      )}
    </div>
  );
};

export default SupporterPass;